import React, { useContext, useRef, useState } from 'react'
import './Contact.css'
import emailjs from '@emailjs/browser'
import { themeContext } from '../../Context'

const Contact = () => {
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
  const form = useRef()
  const [done, setDone] = useState(false)
  const [error, setError] = useState(false)

  const sendEmail = (event) => {
    event.preventDefault()
    setDone(false)
    setError(false)

    emailjs.sendForm('service_1cq2kck', 'template_gmvpumf', form.current, {
      publicKey: 'l0QaTSxMo5_hRiHG4'
    }).then(
      () => {
        setDone(true)
        form.current.reset()
      },
      () => setError(true)
    )
  }

  return (
    <section className='contact-form site-shell' id='Contact'>
      <div className='c-left'>
        <span className='section-eyebrow'>Contact</span>
        <h2 className='section-title' style={{ color: darkMode ? 'white' : '' }}>Let us build something useful.</h2>
        <p className='section-copy'>
          Available for full-stack roles, remote collaboration, product builds, dashboards, API work, and software maintenance contracts.
        </p>
        <div className='contact-direct'>
          <span>Email</span>
          <a href='mailto:exauceboby15@gmail.com'>exauceboby15@gmail.com</a>
        </div>
      </div>

      <div className='c-right'>
        <form ref={form} onSubmit={sendEmail}>
          <label>
            <span>Name</span>
            <input required type='text' name='user_name' placeholder='Your name' />
          </label>
          <label>
            <span>Email</span>
            <input required type='email' name='user_email' placeholder='you@example.com' />
          </label>
          <label>
            <span>Message</span>
            <textarea required name='message' placeholder='Tell me what you want to build' />
          </label>
          <input type='submit' value='Send message' className='button' />
          <p className='form-status'>{done && 'Thank you. Your message has been sent.'}</p>
          <p className='form-status form-error'>{error && 'The message could not be sent. Please email me directly.'}</p>
        </form>
      </div>
    </section>
  )
}

export default Contact
